import { atom } from 'recoil';

export const DEFAULT_QUOTE_INFO = {
  branchNumber: '',
  endUserInformation: '',
  quoteGuid: '',
  quoteLinesItems: [],
  quoteNumber: '',
};

export interface QuoteInformationAtom {
  branchNumber: string;
  endUserInformation: string;
  quoteGuid: string;
  quoteLinesItems: any[];
  quoteNumber: string;
}

export const quoteInformationAtom = atom<QuoteInformationAtom>({
  default: DEFAULT_QUOTE_INFO,
  key: 'quoteInformationAtom',
});
